import { Layer, Source } from "react-map-gl";

interface MapSourceProps {
  id: string;
  data: any;
  layers: any[];
}

export const MapSource = ({ id, data, layers }: MapSourceProps) => {
  const geojson = data
    ? data
    : {
        type: "FeatureCollection",
        features: [],
      };

  return (
    <Source id={id} type="geojson" data={geojson}>
      {layers.map((layer, index) => (
        <Layer key={index} {...layer} />
      ))}
    </Source>
  );
};
